import { createWebHistory, createRouter } from "vue-router";
import Dashboard from "@/components/Home.vue";
import Welcome from "@/components/Welcome.vue";
import BaseRoute from "./base-route";

import MasterDataRoute from "./masterdata-route";
import TransactionRoute from "./transaction-route";
import ReportRoute from "./report-route.js";
//import UploadRoute from "./upload-route.js";
//import LogRoute from "./log-route.js";

const routes = [
  {
    path: "/",
    name: "Welcome",
    component: Welcome,
    meta: {
      name: "Welcome",
      menuTitle: "Welcome",
      requiresAuth: true,
    },
  },
  {
    path: "/Dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: {
      name: "Dashboard",
      menuTitle: "Dashboard",
      requiresAuth: true,
    },
  },
  {
    path: "/JoinCompany/Index",
    name: "JoinCompanyIndex",
    component: () => import("@/components/JoinCompany/Index.vue"),
    meta: {
      name: "JoinCompanyIndex",
      menuTitle: "JoinCompany",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/JoinCompany/Editor",
    name: "JoinCompanyEditor",
    component: () => import("@/components/JoinCompany/Editor.vue"),
    meta: {
      name: "JoinCompanyEditor",
      menuTitle: "JoinCompany",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: () => import("@/components/Base/Helper/NotFound/Index.vue"),
    meta: {
      name: "PageNotFound",
      menuTitle: "Page Not Found",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/:pathMatch(.*)*",
    name: "ActivateAccount",
    component: () =>
      import("@/components/EmailConfirmation/ActivateAccount.vue"),
    meta: {
      name: "ActivateAccount",
      menuTitle: "Activate Account",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/:pathMatch(.*)*",
    name: "ForgetPassword",
    component: () =>
      import("@/components/EmailConfirmation/ForgetPassword.vue"),
    meta: {
      name: "ForgetPassword",
      menuTitle: "Forget Password",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/:pathMatch(.*)*",
    name: "InvalidToken",
    component: () => import("@/components/EmailConfirmation/InvalidToken.vue"),
    meta: {
      name: "InvalidToken",
      menuTitle: "Invalid Token",
      requiresAuth: true,
    },
    props: true,
  },
  {
    path: "/",
    name: "Denied",
    component: () => import("@/components/Denied.vue"),
    meta: {
      name: "Denied",
      menuTitle: "Access Denied",
      requiresAuth: true,
    },
    props: true,
  },
  ...BaseRoute,
  ...MasterDataRoute,
  ...TransactionRoute,
  ...ReportRoute,
  //...UploadRoute,
  //...LogRoute
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
